import { AnimalSex, AnimalOrganSystem, CerberusIntegrationStatus } from 'types/types';
import { PharmaceuticalType, PharmaceuticalTypeOption } from 'components/registry/types/api';
import { CerberusIntegrationStatusDictOption, DictOption } from './params';

export const animalSexOptions = [
  {
    value: AnimalSex.MALE,
    label: 'Самец',
  },
  {
    value: AnimalSex.FEMALE,
    label: 'Самка',
  },
  {
    value: AnimalSex.MIXED,
    label: 'Смешанный',
  },
];

export const AnimalOrganSystemOptions = [
  {
    value: AnimalOrganSystem.NERVOUS,
    label: 'Центральная нервная и периферическая нервная системы, включая органы чувств',
  },
  {
    value: AnimalOrganSystem.CARDIOVASCULAR,
    label: 'Сердечно-сосудистая система',
  },
  {
    value: AnimalOrganSystem.EXCRETORY,
    label: 'Выделительная система',
  },
  {
    value: AnimalOrganSystem.RESPIRATORY,
    label: 'Дыхательная система',
  },
  {
    value: AnimalOrganSystem.DIGESTIVE,
    label: 'Пищеварительная система',
  },
  {
    value: AnimalOrganSystem.REPRODUCTIVE,
    label:
      'Репродуктивная система и молочные железы, включая тератогенное и эмбриотоксическое действие',
  },
  {
    value: AnimalOrganSystem.SKELETAL,
    label: 'Опорно-двигательная система',
  },
  {
    value: AnimalOrganSystem.IMMUNE,
    label: 'Иммунная система',
  },
  {
    value: AnimalOrganSystem.INBORN_ERRORS,
    label: 'Врожденные, наследственные и генетические нарушения',
  },
  {
    value: AnimalOrganSystem.OTHER,
    label: 'Прочие системы',
  },
];

export const yesNoOptions: DictOption[] = [
  {
    value: 'true',
    label: 'Да',
  },
  {
    value: 'false',
    label: 'Нет',
  },
];

export const pharmaceuticalTypeOptions: PharmaceuticalTypeOption[] = [
  {
    value: PharmaceuticalType.VACCINE,
    label: 'Вакцина',
  },
  {
    value: PharmaceuticalType.ANTIBIOTIC,
    label: 'Антибиотик',
  },
  {
    value: PharmaceuticalType.OTHER,
    label: 'Прочие лекарственные средства',
  },
];

export const GOS_REGISTRATION_REJECTED_ID = '32e260dc-1c3a-935f-da0e-6006ae573f91';

export const productPackagingOptions: DictOption[] = [
  {
    value: 'true',
    label: 'нерасфасованная',
  },
  {
    value: 'false',
    label: 'расфасованная',
  },
];

export const cerberusIntegrationStatusOptions: CerberusIntegrationStatusDictOption[] = [
  { value: CerberusIntegrationStatus.NOT_LINKED_WITH_CERBERUS, label: 'ХС не связан с Цербер' },
  { value: CerberusIntegrationStatus.ENTERED_MANUALLY, label: 'ХС введен вручную' },
];
